module.exports = __webpack_public_path__ + "img/rotate.11e8ce4a.png";